<app-organizer-shared-form-wrapper
  class="organizer-activity-creation-page-duration"
  [activeStep]="0"
  [error$]="error$"
  [formGroup]="formGroup"
  [sectionDescription]="sectionDescriptionKey | translate"
  [sectionTitle]="'activity_creation.duration.section.title' | translate"
  [tipsConfig]="tipsConfig"
  (formSubmit)="submit($event)"
>
  <ng-container *ngIf="isCourseType || isEventType">
    <app-form-control>
      <app-input-counter
        formControlName="dayDuration"
        [help]="'activity_creation.duration.form.day_duration.help' | translate"
        [label]="
          'activity_creation.duration.form.day_duration.label' | translate
        "
        [min]="1"
      ></app-input-counter>
    </app-form-control>
    <app-form-control
      [label]="
        'activity_creation.duration.form.course_start_time.label' | translate
      "
    >
      <app-form-input
        #controlChild
        type="time"
        formControlName="courseStartTime"
      ></app-form-input>
    </app-form-control>
    <app-form-control
      [label]="
        'activity_creation.duration.form.course_end_time.label' | translate
      "
    >
      <app-form-input
        #controlChild
        type="time"
        formControlName="courseEndTime"
      ></app-form-input>
    </app-form-control>
  </ng-container>

  <ng-container *ngIf="!isCourseType && !isEventType">
    <app-form-input-group
      [label]="timeDurationLabelKey | translate"
      [errors]="getErrors('timeDuration')"
      [errorKey]="'time_duration'"
    >
      <app-form-duration
        #content
        formControlName="timeDuration"
      ></app-form-duration>
    </app-form-input-group>
  </ng-container>

  <ng-container *ngIf="isBookableUntilTheEndEnabled">
    <app-form-checkbox
      formControlName="bookableUntilTheEnd"
      class="block mt-4 mb-4"
      label="{{
        'activity_creation.duration.form.bookable_until_the_end' | translate
      }}"
    ></app-form-checkbox>
  </ng-container>
</app-organizer-shared-form-wrapper>
